"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var classroomState = new _GatewayService["default"]('classroom-state');

var fetchClassroomState = function fetchClassroomState(classKey, fileKey) {
  return classroomState.get("state/".concat(classKey, "/").concat(fileKey));
};

var saveClassroomState = function saveClassroomState(classKey, fileKey, body) {
  return classroomState.post("state/".concat(classKey, "/").concat(fileKey), body);
};

var batchFetchClassroomState = function batchFetchClassroomState(body, includeData) {
  return classroomState.post("state/batch-get?includeData=".concat(includeData), body);
};

var batchSaveClassroomState = function batchSaveClassroomState(body) {
  return classroomState.post("state/batch-post", body);
};

var fetchClassroomStateWithPrefix = function fetchClassroomStateWithPrefix(classKey, prefix) {
  return classroomState.get("state/".concat(classKey, "/all/").concat(prefix));
};

var deleteAllClassroomStateWithPrefix = function deleteAllClassroomStateWithPrefix(classKey, prefix) {
  return classroomState["delete"]("state/all/".concat(classKey, "/").concat(prefix));
};

var _default = {
  fetchClassroomState: fetchClassroomState,
  saveClassroomState: saveClassroomState,
  batchFetchClassroomState: batchFetchClassroomState,
  batchSaveClassroomState: batchSaveClassroomState,
  fetchClassroomStateWithPrefix: fetchClassroomStateWithPrefix,
  deleteAllClassroomStateWithPrefix: deleteAllClassroomStateWithPrefix
};
exports["default"] = _default;